module.exports = __webpack_public_path__ + "img/img-outlook.5640c17.png";